import type { HTMLAttributes } from 'react';
import { getInitials } from '@/lib/initials';

export type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

export type AvatarProps = HTMLAttributes<HTMLSpanElement> & {
  name?: string | null;
  src?: string | null;
  size?: AvatarSize;
  /** Optional override label (e.g. ID code). */
  label?: string;
};

export function Avatar({ name, src, size = 'md', label, className = '', ...rest }: AvatarProps) {
  const cls = ['avatar', `avatar-${size}`, className].filter(Boolean).join(' ');
  if (src) {
    return (
      <span className={cls} {...rest}>
        <img src={src} alt={name ?? ''} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }} />
      </span>
    );
  }
  return (
    <span className={cls} aria-label={name ?? undefined} {...rest}>
      {label ?? getInitials(name ?? '')}
    </span>
  );
}
